module.exports = __webpack_public_path__ + "img/img-business-corps-sec-10.png";